import React from 'react'

import ModalReportSelect_ReportPreview from "./report-preview"
import ModalReportSelect_ReportPreviewWithSubitems from "./report-preview-with-subitems"

type Props = {
    group           : any
    onSelectReport  : callback
}

export default function ModalReportSelect_GroupedReportPreview(props: Props) {

    return (
        <div className="flex-column-left-top">
            <div className="ui5-title-small txt-bold">
                {props.group.title}
            </div>

            <div className="flex-row-left-top flex-wrap flex-gap-10">
                {props.group.reports.map((report: any, key: number) => {
                    if (report.subitems?.length) {
                        return (
                            <ModalReportSelect_ReportPreviewWithSubitems
                                key             = {key}
                                item            = {report}
                                onSelectReport  = {props.onSelectReport}
                            />
                        )
                    }
                    return (
                        <ModalReportSelect_ReportPreview
                            key             = {key}
                            report          = {report}
                            onSelectReport  = {props.onSelectReport}
                        />
                    )
                })}
            </div>
        </div>
    )
}
